<template>
  <div class="container">
    <div class="table-page-search-wrapper">
      <div>
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据类型">
                <a-radio-group :options="typeOption" default-value="2" @change="onTypeChange" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8" >
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间">
                <year-select @change="yearChange"></year-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <a-button
                type="primary"
                style="margin: 0 10px"
                icon="download"
                @click="handleExportXls(`年报表(${name}).xls`)"
                >导出</a-button
              >
              <a-button  @click="openCol" icon="menu-unfold" type="primary" ghost>
              </a-button>
            </a-col>

            <!--<a-col :md="24" :sm="24" style="margin: 10px 0" v-if="colShow">-->
              <!--<a-checkbox-->
                <!--style="margin-right: 10px"-->
                <!--:indeterminate="indeterminate"-->
                <!--:checked="checkAll"-->
                <!--@change="onCheckAllChange"-->
              <!--&gt;-->
                <!--全选-->
              <!--</a-checkbox>-->
              <!--<a-checkbox-group v-model="selectCol" name="checkboxgroup" :options="options" @change="onChange" />-->
            <!--</a-col>-->

          </a-row>
          <a-row>
            <a-col :md="7" :sm="7" v-if="handleOptionsData()">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据状态">
                <a-radio-group :default-value="null" :options="typeOptions" @change="onTypeChange1" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <col-control ref="colControl"  :options="options" @onChange="onChange"></col-control>
        <!-- 数据展示 -->
				<data-card :dataDetail="dataDetail" :quantum="queryParam.quantum?queryParam.quantum+'年':queryParam.quantum"></data-card>
      </div>
    </div>
    <div>
      <a-table
        id="tb"
        ref="table"
        size="middle"
        bordered
        :scroll="scroll"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
      ></a-table>
    </div>
  </div>
</template>
<script>
  import colControl from '@/components/colControl/colControl'
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import { ChangeColMixin } from '@/mixins/ChangeColMixin1'
import yearRange from '@/components/date/yearRange'
import yearSelect from '@/components/date/yearSelect'
import { downloadFile } from '@/api/manage'
import dataCard from './com/dataCard'
export default {
  name: 'St21Cn2061ReportYear',
  data() {
    return {
      isPagination: false,
      isReport: true,
      exportUrl:'',
      typeOption: [
        { label: '月均值', value: '2' },
        { label: '季度均值', value: '3' },
      ],
      name:'月均值',
      scroll:{y: 450},
			siteName:'',
      typeOptions: [
        {
          label: '生产数据',
          value: '1',
        },
        {
          label: '未生产数据',
          value: '2',
        },
        {
          label: '综合数据',
          value: null,
        }
      ],
      showSite: true,
      siteOnly: true,
    }
  },
  components: { yearRange, yearSelect,dataCard,colControl },
  mixins: [GetSiteIdMixin, ChangeColMixin],
  props: ['showSiteTree','siteId','selectType'],
  watch: {
    currentSiteId(value) {
      if(this.showSite){
        var ids = this.getTreeCurrentId()
        this.queryParam.scope = ids[0]
        this.queryParam.scopeId = ids[1]
        this.checkAll = true
        this.indeterminate = false
        if (this.url) this.delayLoadData()
        if(ids[0] == 1){
          if(this.siteType!=31){
            delete this.queryParam.productionStatus
          }
        }
      }
    },
    siteId:{
      handler(value){
        this.queryParam.scope = 1
        this.queryParam.scopeId = value
        this.checkAll = true
        this.indeterminate = false
        if(this.selectType){
          this.siteType = this.selectType
          this.queryParam.type = 5
          this.queryParam.dataType = 2
          this.url = '/online/st' + this.selectType + '/report'
          this.exportUrl = `online/st${this.selectType}/export`
          this.$nextTick(()=>{
            this.queryParam.order = 'asc'
          })
          window.addEventListener('setItem', (e) => {
            if (e.key == 'siteType') {
              this.siteType = this.selectType
              this.url = '/online/st' + this.selectType + '/report'
              this.exportUrl = `online/st${this.selectType}/export`
            }
          })
          if (this.url) this.delayLoadData()
        }
        if(this.selectType!=31){
          delete this.queryParam.productionStatus
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler(value){
        if(value === false){
          this.showSite = false
        }
      },
      deep: true,
      immediate:true
    },
		currentSiteName(value){
			this.siteName = value
		}
  },
  mounted() {
    if(this.selectType){
      this.siteType = this.selectType
      this.queryParam.type = 5
      this.queryParam.dataType = 2
      this.url = '/online/st' + this.selectType + '/report'
      this.exportUrl = `online/st${this.selectType}/export`
      this.$nextTick(()=>{
        this.queryParam.order = 'asc'
      })
      window.addEventListener('setItem', (e) => {
        if (e.key == 'siteType') {
          this.siteType = this.selectType
          this.url = '/online/st' + this.selectType + '/report'
          this.exportUrl = `online/st${this.selectType}/export`
        }
      })
      if (this.url) this.delayLoadData()
    }else{
      this.siteType = window.sessionStorage.getItem('siteType')
      this.queryParam.type = 5
      this.queryParam.dataType = 2
      this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/report'
      this.exportUrl = `online/st${window.sessionStorage.getItem('siteType')}/export`
      this.$nextTick(()=>{
        this.queryParam.order = 'asc'
      })
      window.addEventListener('setItem', (e) => {
        if (e.key == 'siteType') {
          this.siteType = window.sessionStorage.getItem('siteType')

          this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/report'
          this.exportUrl = `online/st${window.sessionStorage.getItem('siteType')}/export`
        }
      })
    }

  },
  methods: {
    onTypeChange(e) {
      this.queryParam.dataType = e.target.value
			this.typeOptions.forEach((item,index)=>{
				if(item.value==e.target.value){
					this.name = item.label
				}
			})
      this.$forceUpdate()
    },
    // 年区间变化
    yearRangeChange(value) {
      this.queryParam.stime = value[0]
      this.queryParam.etime = value[1]
    },
    // 年变化
    yearChange(value) {
      this.queryParam.quantum = value
    },
    onTypeChange1(e){
      console.log('e',e)
      this.queryParam.productionStatus = e.target.value

    }
  },
}
</script>
<style lang="less" scoped>
.container {
  padding: 10px 20px 30px;
  box-sizing: border-box;
}
.redText {
  color: red;
  cursor: pointer;
}
.statusText {
  color: #000;
  padding: 3px 10px;
  border-radius: 10px;
}
</style>
